let colors = [
  '#7ab956',
  '#52d7a7',
  '#b9e170',
  '#fbba39'
];

export default [
  {
    type: 'value',
    position: 'left',
    axisLine: {
      lineStyle: {
        color: colors[0]
      }
    },
    axisLabel: {
      formatter: '{value}'
    },
    minInterval: 1
  },
  {
    type: 'value',
    position: 'right',
    axisLine: {
      lineStyle: {
        color: colors[1]
      }
    },
    axisLabel: {
      formatter: '{value}'
    },
    minInterval: 1
  },
  {
    type: 'value',
    position: 'left',
    offset: 80,
    axisLine: {
      lineStyle: {
        color: colors[2]
      }
    },
    axisLabel: {
      formatter: '{value}'
    },
    minInterval: 1
  },
  {
    type: 'value',
    position: 'right',
    offset: 80,
    axisLine: {
      lineStyle: {
        color: colors[3]
      }
    },
    axisLabel: {
      formatter: '{value}'
    },
    minInterval: 1
  }
]